/**
 * MyClips V3 — Haptic Grammar
 *
 * Single façade over the Vibration API. Respects user preference via a
 * global mute flag (persisted in localStorage). Silent fallback on iOS Safari
 * (no Vibration API support) — the UI never depends on haptics for correctness.
 *
 * MDN reference: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vibrate
 */

const STORAGE_KEY = "mlv3.haptics.enabled";

function isEnabled() {
  if (typeof window === "undefined") return false;
  if (typeof navigator === "undefined" || !navigator.vibrate) return false;
  try {
    const raw = window.localStorage?.getItem(STORAGE_KEY);
    if (raw === "0" || raw === "false") return false;
  } catch (_) {
    // localStorage can throw in incognito/sandbox — default to enabled
  }
  return true;
}

// Doğrudan `navigator.vibrate`e geçiyor; gövdedeki çağrılar tek sayı (8) ve
// dizi ([8,40,8]) — Vibration API'nin `VibratePattern`i ile aynı.
function vibrate(pattern: number | number[]): void {
  if (!isEnabled()) return;
  try {
    navigator.vibrate(pattern);
  } catch (_) {
    // Swallow — vibration is best-effort
  }
}

export const haptics = {
  // Intensities
  light: () => vibrate(8),
  medium: () => vibrate(14),
  heavy: () => vibrate(22),
  rigid: () => vibrate(30),

  // Named patterns
  tap: () => vibrate([8]),
  doubleTap: () => vibrate([8, 40, 8]),
  successPop: () => vibrate([12, 30, 20]),
  errorBuzz: () => vibrate([40, 60, 40, 60, 40]),

  // Preferences
  // Dış çağıranı yok (ölçüldü); tek okuyucu `isEnabled` ve o "0"/"false"
  // dışındaki her şeyi açık sayıyor → sözleşme iki değerlik.
  setEnabled(enabled: boolean) {
    try {
      window.localStorage?.setItem(STORAGE_KEY, enabled ? "1" : "0");
    } catch (_) {}
  },
  getEnabled: isEnabled,
};

export default haptics;
